// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================= ARGOS STRATEGY PAGE ================= */

.argosStrategyPage {
  min-height: 100%;
  padding: 22px;
  color: #f4f4f4;
  background:
    radial-gradient(circle at top left, rgba(177, 136, 0, 0.12), transparent 34%),
    #050505;
}

/* ================= SHARED ================= */

.argosHeroContent,
.argosCommandCard,
.argosStatCard,
.argosInsightCard,
.argosProcessPanel,
.argosTablePanel {
  border: 1px solid rgba(177, 136, 0, 0.28);
  border-radius: 18px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(255, 255, 255, 0.015)),
    #0b0b0b;
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.35);
}

.argosHeroContent,
.argosCommandCard,
.argosStatCard,
.argosInsightCard,
.argosProcessPanel,
.argosTablePanel {
  padding: 20px;
}

.argosEyebrow,
.argosSectionEyebrow,
.argosCommandLabel,
.argosInsightLabel,
.argosStatLabel,
.argosCommandOpenTable th,
.argosTradeTable th {
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.argosEyebrow,
.argosSectionEyebrow,
.argosInsightLabel {
  color: #d8b44c;
  font-size: 0.72rem;
}

.argosCommandLabel,
.argosStatLabel {
  color: rgba(244, 244, 244, 0.52);
  font-size: 0.7rem;
}

/* ================= HERO ================= */

/* ================= HERO ================= */

.argosHero {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(520px, 0.85fr);
  gap: 18px;
  align-items: stretch;
  margin-bottom: 18px;
}

.argosHeroContent,
.argosCommandCard {
  height: 100%;
  box-sizing: border-box;
}

.argosHeroContent {
  padding: 24px 28px;
  position: relative;
  overflow: hidden;
}

.argosEyebrow {
  display: inline-flex;
  width: fit-content;
  letter-spacing: 0.11em;
}

.argosHeroContent h1 {
  margin: 10px 0 0;
  color: #ffffff;
  font-size: clamp(2.4rem, 4vw, 4rem);
  line-height: 0.95;
  letter-spacing: 0.02em;
}

.argosHeroContent h2 {
  margin: 8px 0 0;
  color: #b18800;
  font-size: clamp(1.2rem, 2vw, 1.7rem);
  font-weight: 800;
  letter-spacing: 0;
}

.argosHeroContent p {
  max-width: 900px;
  margin: 14px 0 0;
  color: rgba(244, 244, 244, 0.74);
  font-size: 0.96rem;
  line-height: 1.58;
}

.argosHeroAction {
  display: flex;
  align-items: center;
  margin-top: 18px;
}

.argosHeroFrameworkLink {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 11px 14px;
  border: 1px solid rgba(177, 136, 0, 0.42);
  border-radius: 12px;
  color: #f4d06f;
  background: rgba(177, 136, 0, 0.08);
  font-size: 0.82rem;
  font-weight: 900;
  text-decoration: none;
  transition:
    background 160ms ease,
    border-color 160ms ease,
    transform 160ms ease;
}

.argosHeroFrameworkLink:hover {
  border-color: rgba(216, 180, 76, 0.72);
  background: rgba(177, 136, 0, 0.16);
  transform: translateY(-1px);
}

/* ================= COMMAND CARD ================= */

.argosCommandCard {
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.argosCommandStatus {
  margin: 8px 0 0;
  color: #ffffff;
  font-size: clamp(1.2rem, 2vw, 1.7rem);
  line-height: 1.1;
  font-weight: 800;
}

.argosCommandCard p {
  margin: 14px 0 0;
  color: rgba(244, 244, 244, 0.68);
  font-size: 0.9rem;
  line-height: 1.55;
}

/* ================= COMMAND CENTER STYLE OPEN POSITIONS ================= */

/* ================= COMMAND CENTER STYLE OPEN POSITIONS ================= */

.argosCommandOpenTableWrap {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.075);
  overflow: hidden;
}

.argosCommandOpenTitle {
  margin-bottom: 12px;
}

.argosCommandOpenTitle span {
  display: block;
  color: #ffffff;
  font-size: 1.05rem;
  line-height: 1.2;
  font-weight: 800;
}

.argosCommandOpenTitle small {
  display: block;
  margin-top: 4px;
  color: rgba(244, 244, 244, 0.48);
  font-size: 0.76rem;
  line-height: 1.35;
}

.argosCommandOpenTable {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.argosCommandOpenTable th {
  padding: 9px 5px;
  color: rgba(244, 244, 244, 0.52);
  font-size: 0.64rem;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  white-space: nowrap;
}

.argosCommandOpenTable td {
  padding: 12px 5px;
  color: rgba(244, 244, 244, 0.82);
  font-size: 0.76rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.055);
  vertical-align: middle;
}

/* Compact right-card column layout */
.argosCommandOpenTable th:nth-child(1),
.argosCommandOpenTable td:nth-child(1) {
  width: 12%;
}

.argosCommandOpenTable th:nth-child(2),
.argosCommandOpenTable td:nth-child(2) {
  width: 20%;
}

.argosCommandOpenTable th:nth-child(3),
.argosCommandOpenTable td:nth-child(3) {
  width: 8%;
}

.argosCommandOpenTable th:nth-child(4),
.argosCommandOpenTable td:nth-child(4) {
  width: 42%;
}

.argosCommandOpenTable th:nth-child(5),
.argosCommandOpenTable td:nth-child(5) {
  width: 8%;
}

.argosCommandOpenTable th:nth-child(6),
.argosCommandOpenTable td:nth-child(6) {
  width: 10%;
}

.argosCommandSetupGrid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  min-width: 0;
}

.argosCommandSetupSide {
  display: grid;
  gap: 5px;
  min-width: 0;
}

.argosCommandSetupLabel {
  color: rgba(244, 244, 244, 0.52);
  font-size: 0.62rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.argosCommandLegRow {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.argosCommandLegRow strong {
  color: rgba(244, 244, 244, 0.9);
  font-size: 0.78rem;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.argosSellBubble,
.argosBuyBubble {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  font-size: 0.56rem;
  font-weight: 900;
}

.argosSellBubble {
  border: 1px solid rgba(255, 100, 100, 0.65);
  background: rgba(255, 100, 100, 0.1);
  color: #ff6464;
}

.argosBuyBubble {
  border: 1px solid rgba(85, 209, 122, 0.65);
  background: rgba(85, 209, 122, 0.1);
  color: #55d17a;
}

.argosCommandOpenEmpty {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.075);
  color: rgba(244, 244, 244, 0.48);
  font-size: 0.82rem;
}

/* ================= STATS ================= */

.argosStatsGrid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.argosStatCard {
  min-width: 0;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.075);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.035);
}

.argosStatLabel {
  display: block;
  color: rgba(244, 244, 244, 0.52);
  font-size: 0.7rem;
}

.argosStatValue {
  display: block;
  margin-top: 10px;
  color: #ffffff;
  font-size: 1.45rem;
  line-height: 1;
  font-weight: 800;
  letter-spacing: 0;
  white-space: nowrap;
}

.argosStatSubtext {
  display: block;
  margin-top: 8px;
  color: rgba(244, 244, 244, 0.48);
  font-size: 0.75rem;
  line-height: 1.25;
}

.argosStatCard--gold .argosStatValue {
  color: #ffffff;
}

.argosStatCard--positive .argosStatValue {
  color: #55d17a;
}

.argosStatCard--negative .argosStatValue {
  color: #ff6464;
}

/* ================= NARRATIVE CARDS ================= */

.argosNarrativeGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.argosInsightCard {
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.075);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.035);
}

.argosInsightCard h3 {
  margin: 6px 0 0;
  color: #ffffff;
  font-size: 1.15rem;
  line-height: 1.2;
  letter-spacing: 0;
}

.argosInsightCard p {
  margin: 10px 0 0;
  color: rgba(244, 244, 244, 0.68);
  font-size: 0.9rem;
  line-height: 1.55;
}

/* ================= PROCESS PANEL ================= */

.argosProcessPanel {
  padding: 20px;
  margin-bottom: 18px;
}

.argosPanelHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.argosPanelHeader h2 {
  margin: 6px 0 0;
  color: #ffffff;
  font-size: 1.15rem;
  line-height: 1.2;
  letter-spacing: 0;
}

.argosProcessGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.argosProcessGrid > div {
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.075);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.035);
}

.argosProcessGrid span {
  display: block;
  color: rgba(244, 244, 244, 0.52);
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.argosProcessGrid h3 {
  margin: 10px 0 0;
  color: #ffffff;
  font-size: 1rem;
  line-height: 1.2;
}

.argosProcessGrid p {
  margin: 8px 0 0;
  color: rgba(244, 244, 244, 0.68);
  font-size: 0.86rem;
  line-height: 1.45;
}

/* ================= TABLE PANELS ================= */

.argosTablePanel {
  padding: 20px;
  margin-bottom: 18px;
  overflow: hidden;
}

.argosTableWrap {
  width: 100%;
  overflow-x: auto;
}

.argosTradeTable {
  width: 100%;
  min-width: 680px;
  border-collapse: collapse;
}

.argosTradeTable th {
  padding: 11px 12px;
  color: rgba(244, 244, 244, 0.52);
  font-size: 0.72rem;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.argosTradeTable td {
  padding: 13px 12px;
  color: rgba(244, 244, 244, 0.82);
  font-size: 0.86rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.055);
  vertical-align: middle;
}

.argosTradeTable tbody tr:hover {
  background: rgba(177, 136, 0, 0.055);
}

/* ================= TABLE DETAILS ================= */

.argosStatusPill {
  display: inline-flex;
  align-items: center;
  padding: 5px 9px;
  border-radius: 999px;
  color: rgba(244, 244, 244, 0.75);
  background: rgba(255, 255, 255, 0.07);
  font-size: 0.75rem;
  font-weight: 800;
}

.argosStatusPill--open {
  color: #f4d06f;
  background: rgba(177, 136, 0, 0.08);
}

.argosStatusPill--closed,
.argosStatusPill--win,
.argosStatusPill--positive {
  color: #55d17a;
  background: rgba(85, 209, 122, 0.1);
}

.argosStatusPill--loss,
.argosStatusPill--negative {
  color: #ff6464;
  background: rgba(255, 100, 100, 0.1);
}

.argosPnlCell {
  font-weight: 800;
}

.argosPnlCell--positive {
  color: #55d17a !important;
}

.argosPnlCell--negative {
  color: #ff6464 !important;
}

.argosPnlCell--neutral {
  color: rgba(244, 244, 244, 0.75) !important;
}

.argosEmptyTableCell,
.argosEmptyState {
  padding: 18px 12px;
  color: rgba(244, 244, 244, 0.48);
  text-align: center;
}

/* ================= DISCLAIMER ================= */

.argosDisclaimer {
  margin-top: 18px;
  padding: 14px 16px;
  border: 1px solid rgba(255, 255, 255, 0.075);
  border-radius: 14px;
  color: rgba(244, 244, 244, 0.42);
  background: rgba(255, 255, 255, 0.025);
  font-size: 0.74rem;
  line-height: 1.45;
}

/* ================= RESPONSIVE ================= */

@media (max-width: 1180px) {
  .argosHero {
    grid-template-columns: 1fr;
  }

  .argosProcessGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 860px) {
  .argosStrategyPage {
    padding: 16px;
  }

  .argosStatsGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .argosNarrativeGrid {
    grid-template-columns: 1fr;
  }

  .argosHeroContent,
  .argosCommandCard,
  .argosStatCard,
  .argosInsightCard,
  .argosProcessPanel,
  .argosTablePanel {
    border-radius: 16px;
  }

  .argosCommandOpenTableWrap {
    overflow-x: auto;
  }
}

@media (max-width: 560px) {
  .argosStatsGrid,
  .argosProcessGrid {
    grid-template-columns: 1fr;
  }

  .argosPanelHeader {
    flex-direction: column;
  }

  .argosHeroContent,
  .argosCommandCard,
  .argosStatCard,
  .argosInsightCard,
  .argosProcessPanel,
  .argosTablePanel {
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Styles/ArgosStrategyPage.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd;;WAES;AACX;;AAEA,+CAA+C;;AAE/C;;;;;;EAME,yCAAyC;EACzC,mBAAmB;EACnB;;WAES;EACT,2CAA2C;AAC7C;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA,6CAA6C;;AAE7C,6CAA6C;;AAE7C;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB;;;wBAGsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,qDAAqD;;AAErD;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,4EAA4E;;AAE5E,4EAA4E;;AAE5E;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;EAChD,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,8CAA8C;;AAE9C;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wDAAwD;;AAExD;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,sDAAsD;;AAEtD;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,qDAAqD;;AAErD;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sDAAsD;;AAEtD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;;;EAGE,cAAc;EACd,mCAAmC;AACrC;;AAEA;;EAEE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,mDAAmD;;AAEnD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mDAAmD;;AAEnD;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;;;;IAME,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;;;IAME,aAAa;EACf;AACF","sourcesContent":["/* ================= ARGOS STRATEGY PAGE ================= */\n\n.argosStrategyPage {\n  min-height: 100%;\n  padding: 22px;\n  color: #f4f4f4;\n  background:\n    radial-gradient(circle at top left, rgba(177, 136, 0, 0.12), transparent 34%),\n    #050505;\n}\n\n/* ================= SHARED ================= */\n\n.argosHeroContent,\n.argosCommandCard,\n.argosStatCard,\n.argosInsightCard,\n.argosProcessPanel,\n.argosTablePanel {\n  border: 1px solid rgba(177, 136, 0, 0.28);\n  border-radius: 18px;\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(255, 255, 255, 0.015)),\n    #0b0b0b;\n  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.35);\n}\n\n.argosHeroContent,\n.argosCommandCard,\n.argosStatCard,\n.argosInsightCard,\n.argosProcessPanel,\n.argosTablePanel {\n  padding: 20px;\n}\n\n.argosEyebrow,\n.argosSectionEyebrow,\n.argosCommandLabel,\n.argosInsightLabel,\n.argosStatLabel,\n.argosCommandOpenTable th,\n.argosTradeTable th {\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.argosEyebrow,\n.argosSectionEyebrow,\n.argosInsightLabel {\n  color: #d8b44c;\n  font-size: 0.72rem;\n}\n\n.argosCommandLabel,\n.argosStatLabel {\n  color: rgba(244, 244, 244, 0.52);\n  font-size: 0.7rem;\n}\n\n/* ================= HERO ================= */\n\n/* ================= HERO ================= */\n\n.argosHero {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) minmax(520px, 0.85fr);\n  gap: 18px;\n  align-items: stretch;\n  margin-bottom: 18px;\n}\n\n.argosHeroContent,\n.argosCommandCard {\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.argosHeroContent {\n  padding: 24px 28px;\n  position: relative;\n  overflow: hidden;\n}\n\n.argosEyebrow {\n  display: inline-flex;\n  width: fit-content;\n  letter-spacing: 0.11em;\n}\n\n.argosHeroContent h1 {\n  margin: 10px 0 0;\n  color: #ffffff;\n  font-size: clamp(2.4rem, 4vw, 4rem);\n  line-height: 0.95;\n  letter-spacing: 0.02em;\n}\n\n.argosHeroContent h2 {\n  margin: 8px 0 0;\n  color: #b18800;\n  font-size: clamp(1.2rem, 2vw, 1.7rem);\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.argosHeroContent p {\n  max-width: 900px;\n  margin: 14px 0 0;\n  color: rgba(244, 244, 244, 0.74);\n  font-size: 0.96rem;\n  line-height: 1.58;\n}\n\n.argosHeroAction {\n  display: flex;\n  align-items: center;\n  margin-top: 18px;\n}\n\n.argosHeroFrameworkLink {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 11px 14px;\n  border: 1px solid rgba(177, 136, 0, 0.42);\n  border-radius: 12px;\n  color: #f4d06f;\n  background: rgba(177, 136, 0, 0.08);\n  font-size: 0.82rem;\n  font-weight: 900;\n  text-decoration: none;\n  transition:\n    background 160ms ease,\n    border-color 160ms ease,\n    transform 160ms ease;\n}\n\n.argosHeroFrameworkLink:hover {\n  border-color: rgba(216, 180, 76, 0.72);\n  background: rgba(177, 136, 0, 0.16);\n  transform: translateY(-1px);\n}\n\n/* ================= COMMAND CARD ================= */\n\n.argosCommandCard {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.argosCommandStatus {\n  margin: 8px 0 0;\n  color: #ffffff;\n  font-size: clamp(1.2rem, 2vw, 1.7rem);\n  line-height: 1.1;\n  font-weight: 800;\n}\n\n.argosCommandCard p {\n  margin: 14px 0 0;\n  color: rgba(244, 244, 244, 0.68);\n  font-size: 0.9rem;\n  line-height: 1.55;\n}\n\n/* ================= COMMAND CENTER STYLE OPEN POSITIONS ================= */\n\n/* ================= COMMAND CENTER STYLE OPEN POSITIONS ================= */\n\n.argosCommandOpenTableWrap {\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid rgba(255, 255, 255, 0.075);\n  overflow: hidden;\n}\n\n.argosCommandOpenTitle {\n  margin-bottom: 12px;\n}\n\n.argosCommandOpenTitle span {\n  display: block;\n  color: #ffffff;\n  font-size: 1.05rem;\n  line-height: 1.2;\n  font-weight: 800;\n}\n\n.argosCommandOpenTitle small {\n  display: block;\n  margin-top: 4px;\n  color: rgba(244, 244, 244, 0.48);\n  font-size: 0.76rem;\n  line-height: 1.35;\n}\n\n.argosCommandOpenTable {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.argosCommandOpenTable th {\n  padding: 9px 5px;\n  color: rgba(244, 244, 244, 0.52);\n  font-size: 0.64rem;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  white-space: nowrap;\n}\n\n.argosCommandOpenTable td {\n  padding: 12px 5px;\n  color: rgba(244, 244, 244, 0.82);\n  font-size: 0.76rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.055);\n  vertical-align: middle;\n}\n\n/* Compact right-card column layout */\n.argosCommandOpenTable th:nth-child(1),\n.argosCommandOpenTable td:nth-child(1) {\n  width: 12%;\n}\n\n.argosCommandOpenTable th:nth-child(2),\n.argosCommandOpenTable td:nth-child(2) {\n  width: 20%;\n}\n\n.argosCommandOpenTable th:nth-child(3),\n.argosCommandOpenTable td:nth-child(3) {\n  width: 8%;\n}\n\n.argosCommandOpenTable th:nth-child(4),\n.argosCommandOpenTable td:nth-child(4) {\n  width: 42%;\n}\n\n.argosCommandOpenTable th:nth-child(5),\n.argosCommandOpenTable td:nth-child(5) {\n  width: 8%;\n}\n\n.argosCommandOpenTable th:nth-child(6),\n.argosCommandOpenTable td:nth-child(6) {\n  width: 10%;\n}\n\n.argosCommandSetupGrid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 12px;\n  align-items: start;\n  min-width: 0;\n}\n\n.argosCommandSetupSide {\n  display: grid;\n  gap: 5px;\n  min-width: 0;\n}\n\n.argosCommandSetupLabel {\n  color: rgba(244, 244, 244, 0.52);\n  font-size: 0.62rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.argosCommandLegRow {\n  display: grid;\n  grid-template-columns: 20px minmax(0, 1fr);\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n}\n\n.argosCommandLegRow strong {\n  color: rgba(244, 244, 244, 0.9);\n  font-size: 0.78rem;\n  font-weight: 800;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.argosSellBubble,\n.argosBuyBubble {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  font-size: 0.56rem;\n  font-weight: 900;\n}\n\n.argosSellBubble {\n  border: 1px solid rgba(255, 100, 100, 0.65);\n  background: rgba(255, 100, 100, 0.1);\n  color: #ff6464;\n}\n\n.argosBuyBubble {\n  border: 1px solid rgba(85, 209, 122, 0.65);\n  background: rgba(85, 209, 122, 0.1);\n  color: #55d17a;\n}\n\n.argosCommandOpenEmpty {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.075);\n  color: rgba(244, 244, 244, 0.48);\n  font-size: 0.82rem;\n}\n\n/* ================= STATS ================= */\n\n.argosStatsGrid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.argosStatCard {\n  min-width: 0;\n  padding: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.075);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.035);\n}\n\n.argosStatLabel {\n  display: block;\n  color: rgba(244, 244, 244, 0.52);\n  font-size: 0.7rem;\n}\n\n.argosStatValue {\n  display: block;\n  margin-top: 10px;\n  color: #ffffff;\n  font-size: 1.45rem;\n  line-height: 1;\n  font-weight: 800;\n  letter-spacing: 0;\n  white-space: nowrap;\n}\n\n.argosStatSubtext {\n  display: block;\n  margin-top: 8px;\n  color: rgba(244, 244, 244, 0.48);\n  font-size: 0.75rem;\n  line-height: 1.25;\n}\n\n.argosStatCard--gold .argosStatValue {\n  color: #ffffff;\n}\n\n.argosStatCard--positive .argosStatValue {\n  color: #55d17a;\n}\n\n.argosStatCard--negative .argosStatValue {\n  color: #ff6464;\n}\n\n/* ================= NARRATIVE CARDS ================= */\n\n.argosNarrativeGrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.argosInsightCard {\n  padding: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.075);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.035);\n}\n\n.argosInsightCard h3 {\n  margin: 6px 0 0;\n  color: #ffffff;\n  font-size: 1.15rem;\n  line-height: 1.2;\n  letter-spacing: 0;\n}\n\n.argosInsightCard p {\n  margin: 10px 0 0;\n  color: rgba(244, 244, 244, 0.68);\n  font-size: 0.9rem;\n  line-height: 1.55;\n}\n\n/* ================= PROCESS PANEL ================= */\n\n.argosProcessPanel {\n  padding: 20px;\n  margin-bottom: 18px;\n}\n\n.argosPanelHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.argosPanelHeader h2 {\n  margin: 6px 0 0;\n  color: #ffffff;\n  font-size: 1.15rem;\n  line-height: 1.2;\n  letter-spacing: 0;\n}\n\n.argosProcessGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.argosProcessGrid > div {\n  padding: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.075);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.035);\n}\n\n.argosProcessGrid span {\n  display: block;\n  color: rgba(244, 244, 244, 0.52);\n  font-size: 0.7rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.argosProcessGrid h3 {\n  margin: 10px 0 0;\n  color: #ffffff;\n  font-size: 1rem;\n  line-height: 1.2;\n}\n\n.argosProcessGrid p {\n  margin: 8px 0 0;\n  color: rgba(244, 244, 244, 0.68);\n  font-size: 0.86rem;\n  line-height: 1.45;\n}\n\n/* ================= TABLE PANELS ================= */\n\n.argosTablePanel {\n  padding: 20px;\n  margin-bottom: 18px;\n  overflow: hidden;\n}\n\n.argosTableWrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.argosTradeTable {\n  width: 100%;\n  min-width: 680px;\n  border-collapse: collapse;\n}\n\n.argosTradeTable th {\n  padding: 11px 12px;\n  color: rgba(244, 244, 244, 0.52);\n  font-size: 0.72rem;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.argosTradeTable td {\n  padding: 13px 12px;\n  color: rgba(244, 244, 244, 0.82);\n  font-size: 0.86rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.055);\n  vertical-align: middle;\n}\n\n.argosTradeTable tbody tr:hover {\n  background: rgba(177, 136, 0, 0.055);\n}\n\n/* ================= TABLE DETAILS ================= */\n\n.argosStatusPill {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 9px;\n  border-radius: 999px;\n  color: rgba(244, 244, 244, 0.75);\n  background: rgba(255, 255, 255, 0.07);\n  font-size: 0.75rem;\n  font-weight: 800;\n}\n\n.argosStatusPill--open {\n  color: #f4d06f;\n  background: rgba(177, 136, 0, 0.08);\n}\n\n.argosStatusPill--closed,\n.argosStatusPill--win,\n.argosStatusPill--positive {\n  color: #55d17a;\n  background: rgba(85, 209, 122, 0.1);\n}\n\n.argosStatusPill--loss,\n.argosStatusPill--negative {\n  color: #ff6464;\n  background: rgba(255, 100, 100, 0.1);\n}\n\n.argosPnlCell {\n  font-weight: 800;\n}\n\n.argosPnlCell--positive {\n  color: #55d17a !important;\n}\n\n.argosPnlCell--negative {\n  color: #ff6464 !important;\n}\n\n.argosPnlCell--neutral {\n  color: rgba(244, 244, 244, 0.75) !important;\n}\n\n.argosEmptyTableCell,\n.argosEmptyState {\n  padding: 18px 12px;\n  color: rgba(244, 244, 244, 0.48);\n  text-align: center;\n}\n\n/* ================= DISCLAIMER ================= */\n\n.argosDisclaimer {\n  margin-top: 18px;\n  padding: 14px 16px;\n  border: 1px solid rgba(255, 255, 255, 0.075);\n  border-radius: 14px;\n  color: rgba(244, 244, 244, 0.42);\n  background: rgba(255, 255, 255, 0.025);\n  font-size: 0.74rem;\n  line-height: 1.45;\n}\n\n/* ================= RESPONSIVE ================= */\n\n@media (max-width: 1180px) {\n  .argosHero {\n    grid-template-columns: 1fr;\n  }\n\n  .argosProcessGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 860px) {\n  .argosStrategyPage {\n    padding: 16px;\n  }\n\n  .argosStatsGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .argosNarrativeGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .argosHeroContent,\n  .argosCommandCard,\n  .argosStatCard,\n  .argosInsightCard,\n  .argosProcessPanel,\n  .argosTablePanel {\n    border-radius: 16px;\n  }\n\n  .argosCommandOpenTableWrap {\n    overflow-x: auto;\n  }\n}\n\n@media (max-width: 560px) {\n  .argosStatsGrid,\n  .argosProcessGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .argosPanelHeader {\n    flex-direction: column;\n  }\n\n  .argosHeroContent,\n  .argosCommandCard,\n  .argosStatCard,\n  .argosInsightCard,\n  .argosProcessPanel,\n  .argosTablePanel {\n    padding: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
